'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render"];
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import { useRenderElement } from '@mui/x-scheduler-headless/base-ui-copy';
import { useAdapterContext } from '@mui/x-scheduler-headless/use-adapter-context';
import { useElementPositionInCollection } from '@mui/x-scheduler-headless/internals';
import { schedulerNowSelectors } from '@mui/x-scheduler-headless/scheduler-selectors';
import { processDate } from '@mui/x-scheduler-headless/process-date';
import { useEventTimelinePremiumStoreContext } from "../../use-event-timeline-premium-store-context/index.mjs";
import { eventTimelinePremiumViewSelectors } from "../../event-timeline-premium-selectors/index.mjs";
import { TimelineGridCurrentTimeIndicatorCssVars } from "./TimelineGridCurrentTimeIndicatorCssVars.mjs";
export const TimelineGridCurrentTimeIndicator = /*#__PURE__*/React.forwardRef(function TimelineGridCurrentTimeIndicator(componentProps, forwardedRef) {
  const adapter = useAdapterContext();
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const store = useEventTimelinePremiumStoreContext();
  const now = useStore(store, schedulerNowSelectors.nowUpdatedEveryMinute);
  const viewConfig = useStore(store, eventTimelinePremiumViewSelectors.config);
  const processedNow = React.useMemo(() => processDate(now, adapter), [adapter, now]);
  const endForCalc = React.useMemo(() => processDate(adapter.addMinutes(now, 1), adapter), [adapter, now]);
  const {
    position
  } = useElementPositionInCollection({
    start: processedNow,
    end: endForCalc,
    collectionStart: viewConfig.start,
    collectionEnd: viewConfig.end
  });
  const style = React.useMemo(() => ({
    [TimelineGridCurrentTimeIndicatorCssVars.xPosition]: position
  }), [position]);
  const props = {
    style
  };
  const isOutOfRange = adapter.isBefore(now, viewConfig.start) || adapter.isAfter(now, viewConfig.end);
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [props, elementProps],
    enabled: !isOutOfRange
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridCurrentTimeIndicator.displayName = "TimelineGridCurrentTimeIndicator";